import { configure as configureWidget } from 'instantsearch.js/es/widgets'
const today = Math.floor(new Date().getTime() / 1000)

console.log(today)
export const configure = configureWidget({
  hitsPerPage: 50,
  distinct: true,
  filters: `status:live AND date_show_recorded < ${today} AND hasRecording:true`,
  facetingAfterDistinct: true,
})
